import React from "react";
import { MessageDescriptor } from "react-intl";

import { useFormatMessageMap } from "src/common/hooks/useFormatMessageMap";

export function useFormatEnum(messages: {
	[key: string]: MessageDescriptor;
}): (key: keyof typeof messages) => string {
	const formatMessage = useFormatMessageMap();
	return React.useCallback(
		(key: keyof typeof messages) => {
			if (!key || !(key in messages)) {
				return "";
			}
			return formatMessage(messages, key as string);
		},
		[formatMessage, messages]
	);
}
